import React from "react";
import {HashLink as Link} from 'react-router-hash-link';
import Panel from "../../Panel";
import {publicBuildUrl} from "../../../config/config";
import Modal from "../../Modal";

const SnavelIngredienten = () => (
    <Modal>
        <div>
            <Panel title={'Ingrediënten voor een goed gesprek'}
                   link={'Lees meer'}
                   intro={'Gespreksvaardigheden die helpend zijn om het gesprek aan te gaan met het kind'}
                    open={true}>

                <p>Gespreksvaardigheden die helpend zijn om het gesprek aan te gaan met het kind</p>

                <p className={'text'}>
                    Wanneer je je zorgen maakt over een kind is het belangrijk om hierover het gesprek
                    aan te gaan met het kind. Zo’n gesprek kan je helpen om zorgen te onderbouwen of
                    weg te nemen. In uitzonderlijke situaties kan er voor gekozen worden om niet met de
                    jeugdige in gesprek te gaan. Dat is het geval wanneer daarmee de veiligheid van
                    betrokkenen ernstig in het geding is (denk aan seksueel geweld, huwelijksdwang,
                    eergerelateerd geweld, loverboy problematiek). Vraag dan advies aan een
                    deskundige zoals Veilig Thuis. Soms is het wel mogelijk om samen met een andere
                    professional het gesprek aan te gaan. Noteer de redenen om (nog) niet met het kind
                    in gesprek te gaan altijd in het dossier.
                </p>

                <p className={'text'}>
                    Gespreksvaardigheden heb je nodig om het kind in de gelegenheid te stellen om zijn
                    verhaal te doen en om daar goed naar te luisteren. In ieder gesprek gebruik je
                    gesprekstechnieken. Waarschijnlijk doe je dat deels bewust, deels onbewust. In
                    gesprekken met kinderen over hun onveilig thuissituatie is het van belang dat je het
                    kind de gelegenheid geeft om zijn verhaal te doen en je het kind geen woorden in de
                    mond legt. Gesprekstechnieken kunnen daarbij helpen. Wanneer een kind niet wil
                    praten ,hoeft hij dat natuurlijk niet. Maar soms heeft een kind gewoon wat hulp nodig
                    om te verwoorden wat er aan de hand is en hoe hij zijn situatie beleefd.
                </p>

                <p className={'text'}>
                    Maak contact, wees een mens, kies een goed moment, de juiste plek en neem de tijd
                    voor een gesprek. Maak ook contact aan het einde van het gesprek. Ben transparant
                    en betrouwbaar. Zeg wat je doet en doe wat je zegt. Leg uit waarom je doet wat je
                    doet en vanuit welke rol je dit doet. Geef antwoord op vragen en als je ze niet kan
                    beantwoorden spreek dan af hoe het kind alsnog een antwoord kan krijgen. Wees
                    eerlijk, ook als dat voor het kind niet is wat hij op dat moment graag wil horen. Geef
                    regie en kaders aan het kind. Accepteer emoties die er zijn. Respecteer grenzen.
                    Geef het goede voorbeeld. Stop als het genoeg is. Dwing nooit tot praten.
                </p>

                <h3>Luisteren</h3>
                <p className={'text'}>
                    Het is van belang om echt te luisteren. Laat merken dat je aandacht hebt voor hun
                    verhaal, hun visie, hun vragen en hun beleving. Dat doe je met name non-verbaal:
                    met oogcontact, je mimiek, lichaamshouding en stemgebruik laat je zien dat je
                    betrokken bent bij het kind en zijn verhaal. Ook stiltes zijn welkom. Als het gesprek
                    heel snel gaat of emoties oplopen dan kan stilte rust en ruimte geven. De
                    informatieverwerking van kinderen verloopt trager dan die van volwassenen. Ook
                    vanuit dat oogpunt is het zinvol om een kind de tijd te geven om jouw vraag of
                    informatie te verwerken.
                </p>

                <h3>Samenvatten</h3>
                <p className={'text'}>
                    Als een kind vertelt over moeilijke dingen, kan het gebeuren dat het stokt of af en toe
                    de draad kwijtraakt. Ook kan het gebeuren dat jij niet zeker weet of je het kind wel
                    goed begrijpt of dat je het kind juist heel goed denkt te begrijpen, terwijl het kind het
                    gevoel heeft van niet. Regelmatig een korte samenvatting zorgt voor afstemming en
                    structuur in het gesprek. Ook kan een samenvatting zorgen voor meer rust in het
                    gesprek. Een samenvatting in eigen woorden werkt het beste. Letterlijk herhalen wat
                    het kind heeft gezegd, voegt niets toe en kan zelfs voor irritatie zorgen. Als jou meer
                    duidelijk is geworden over zowel feiten als beleving, zorg er dan voor dat ze allebei
                    terugkomen in je samenvatting. Op die manier laat je het kind merken dat je zowel
                    benieuwd bent naar wat er speelt als dat je aandacht hebt voor hoe het met het kind
                    gaat nu het in deze situatie zit.
                </p>

                <h3>Doorvragen</h3>
                <p className={'text'}>
                    In een goed gesprek is doorvragen essentieel. Doordat je ingaat op wat een kind je
                    vertelt, geef je het kind de gelegenheid om stukje bij beetje zijn verhaal te doen. Door
                    de juiste vragen te stellen, krijg je een steeds duidelijker beeld over de situatie en
                    over hoe het met het kind gaat. Wat de juiste vragen zijn, hangt uiteraard af van wat
                    er aan de hand is en van wat het betreffende kind kan en aankan. Toch is er in het
                    algemeen wel wat te zeggen over vragen die je kunt stellen
                </p>

                <h3>Open vragen</h3>
                <p className={'text'}>
                    Stel vooral open vragen. Met open vragen geef je het kind het meest de gelegenheid
                    om verhaal te doen. Met alleen losse vragen blijf je doorgaans echter aan de
                    oppervlakte.
                </p>

                <h3>Gesloten vragen</h3>
                <p className={'text'}>
                    Met gesloten vragen loop je het risico dat je het gesprek te veel stuurt. Toch kan af
                    en toe doorvragen met een gesloten vraag geen kwaad en juist belangrijke informatie
                    opleveren. Wissel gesloten vragen altijd af met open vragen om te voorkomen dat je
                    te sturend wordt.
                </p>

                <h3>Mijd waaromvragen</h3>
                <p className={'text'}>
                    Met een waaromvraag roep je de ander ter verantwoording. Dat kan een kind het
                    gevoel geven dat het zich moet verdedigen. Daarnaast is een waaromvraag een
                    nogal abstracte vraag en daardoor voor veel kinderen erg moeilijk te beantwoorden.
                    Maak er liever een wat-vraag van. Bijvoorbeeld, in plaats van: ‘Waarom durf je dat
                    niet?’: ‘Wat vind je er spannend aan?’ Of in plaats van ‘Waarom zeg je dat?’: ‘Wat
                    bedoel je daarmee?’
                </p>

                <h3>Gevoelens benoemen</h3>
                <p className={'text'}>
                    Kinderen kunnen nog niet altijd vanuit zichzelf woorden geven aan hun emoties. Uit
                    hun gedrag of manier van praten, merk je vaak wel degelijk hoe een kind zich voelt.
                    Wanneer je een emotie opmerkt bij een kind, kun je deze benoemen. Je maakt
                    daarbij duidelijk dat het gaat om jouw observatie of interpretatie. Bijvoorbeeld: ‘Ik zie
                    dat je er zenuwachtig van wordt’. Op die manier leert een kind zijn eigen emoties
                    herkennen en geef je tegelijkertijd erkenning voor het feit dat elke emotie er is en
                    mag zijn. Ook is het benoemen van gevoelens een manier om te laten merken dat je
                    de emotie van het kind gezien hebt, zonder samen met het kind ‘mee in de put te
                    zakken’. Sms kan een emotie een gesprek zelfs zodanig in de weg zitten.
                    Bijvoorbeeld: wanneer een kind heel boos of heel verdrietig is en daardoor niet goed
                    kan luisteren naar wat je zegt of vraagt en niet goed kan nadenken. Even de ruimte
                    geven voor de emotie door deze te benoemen, kan dan goed werken. Wanneer je
                    een emotie benoemt wordt deze vaak eerst even groter. Wat later zakt de emotie
                    weer en kun je vaak weer verder met het gesprek. Het benoemen van gevoelens
                    zorgt voor afstemming: je weet blijkbaar hoe het kind zich voelt en het kind voelt zich
                    daardoor ook werkelijk gezien. Wanneer een kind zich toch anders voelt dan jij dacht
                    te zien, dan kan je dat direct bespreekbaar maken.
                </p>

                <h3>Empathie tonen</h3>
                <p className={'text'}>
                    Kinderen die kindermishandeling meemaken, kunnen zich heel alleen voelen. Dat
                    eenzame gevoel kun je wat verkleinen dor in een gesprek expliciet jouw
                    betrokkenheid te laten merken. Niet samen wegzakken in de put, maar wel laten
                    merken dat je je verplaatst in het kind en dat het je wat kan schelen hoe het met hem
                    gaat.
                </p>

                <h3>Complimenteren</h3>
                <p className={'text'}>
                    Met complimenten zet je een kind in zijn kracht. Heel belangrijk, juist wanneer hij veel
                    narigheid meemaakt. Een compliment wordt extra krachtig wanneer je zowel het
                    positieve gedrag van het kind als het effect van dat gedrag benoemt. Op die manier
                    leert een kind dat het op bepaalde zaken wel invloed heeft en dat het loont om
                    bepaald gedrag te laten zien.
                </p>

                <h3>Gespreksstructuur</h3>
                <p className={'text'}>
                    Wanneer je met een kind in gesprek gaat over zijn onveilige thuissituatie, is het
                    handig als zo’n gesprek enigszins gestructureerd verloopt, zodat je enerzijds
                    voldoende ruimte geeft voor het verhaal van het kind en anderzijds toekomt aan je
                    taak, bijvoorbeeld het verhelderen van signalen en het uitzetten van de
                    eerstvolgende stap.
                </p>
                <p className={'text'}>
                    Het 5-fasenmodel van Gemert en Hoogenhuyze (2013) is goed bruikbaar voor
                    gesprekken waarin je signalen verheldert en/of een luisterend oor biedt, mar ook voor
                    gesprekken waarin je samen met het kind mogelijke oplossingen of een
                    eerstvolgende stap bespreekt. De 5 fasen zijn als volgt:
                </p>

                <h3>Contact maken</h3>
                <p className={'text'}>
                    Voor een goed gesprek is het nodig dat er ‘contact’ is tussen de gesprekspartners.
                    Ieder gesprek begint daarom met het maken van contact. Allereerst doe je dat vanuit
                    je eigen mens zijn. Een vraag over waar het kind zojuist mee bezig was, een grapje,
                    compliment of benoemen wat je merkt aan het kind; een kort aanloopje om het kind
                    te laten merken dat je hem ziet en waarin je idealiter ook iets van jezelf laat zien.
                    Wanneer je initiatief neemt voor het gesprek, leg je meteen daarna kort uit wat de
                    aanleiding is voor het gesprek en waar je met het kind over wilt praten. Wanneer het
                    kind zelf naar je toe komt met zijn verhaal, is even contact maken meestal
                    voldoende.
                </p>

                <h3>Exploreren</h3>
                <p className={'text'}>
                    Wanneer je contact hebt gemaakt met het kind en je weet allebei wat de aanleiding is
                    voor het gesprek, kun je verder met het verkennen van de situatie en hoe het kind
                    deze beleeft. Idealiter exploreer je op 4 niveaus:
                </p>
                <ol>
                    <li>Feiten (wat is er gebeurd of wat is er aan de hand?)</li>
                    <li>Beleving (hoe ervaart het kind zijn situatie of gebeurtenis; hoe voelt hij zich thuis, op
                        school, en op andere plekken; hoe gaat het kind om met zijn situatie?)
                    </li>
                    <li>Wensen (wat wil het kind graag anders zien; wat is het belangrijkste dat moet gebeuren; hoe zou
                        zijn situatie er idealiter uitzien; hoe zou dat zijn, hoe zou het kind zich dan voelen?)
                    </li>
                    <li>Interactie met jou (heeft het kind het gevoel dat je hem begrijpt?; Hoe loopt het gesprek? Hoe
                        ervaart het kind het contact met jou? Hoe vindt hij het om dit met je te bespreken?)
                    </li>
                </ol>

                <h3>Gespreksdoel vaststellen</h3>
                <p className={'text'}>
                    Nadat je voldoende weet over wat er gaande is en hoe het kind zijn situatie beleeft, is
                    het tijd voor verwachtingsmanagement: wat verwacht het kind van jou? Wat zou hij
                    het liefst willen dat er gebeurt? In hoeverre kun jij hier, al dan niet met behulp van de
                    juiste personen, iets in betekenen? Deze fase van het gesprek volgt vaak logisch uit
                    het exploreren van de wensen in fase 2. Het verschil met het inventariseren van de
                    wensen is dat het nu, in fase 3, gaat over verwachtingen die het kind heeft van jou
                    (wat wil het kind dat je voor hem doet?) Om er zo goed mogelijk achter te komen wat
                    het kind van jou verwacht, is het van belang om dit niet zelf te gaan concluderen uit
                    zijn verhaal, maar er gewoon naar te vragen met een open vraag. Soms is even
                    doorvragen nodig, voordat een kind zijn (hulp)vraag aan jou kan formuleren. Soms
                    lukt het kind, ook na doorvragen, niet om te formuleren wat hij van je verwacht en
                    moet je zelf een voorzet doen. Wanneer helder is wat het kind van jou verwacht, dien
                    je bij jezelf na te gaan of je aan deze verwachting kan voldoen. Soms heb je niet de
                    juiste functie om te kunnen doen wat het kind van je verwacht, of je kunt het niet
                    alleen of niet zo snel als het kind zou willen. Soms wil of moet je, naast hetgeen het
                    kind van je wil, ook nog iets anders doen, vanuit jouw professionele taak of
                    betrokkenheid. Wees daar ook helder over. Probeer tot een gezamenlijk
                    gespreksdoel te komen, alvorens je verder gaat met de rest van het gesprek. Dit kan
                    valse verwachtingen en latere teleurstellingen voorkomen.
                </p>

                <h3>Aanpak bespreken</h3>
                <p className={'text'}>
                    Wat heeft het kind voor ideeen over hoe het zijn doel kan bereiken? Wat als hij alles
                    mag zeggen? Alles zou durven? Wat zijn voor- en nadelen van de verschillende
                    ideeen? Welke optie lijkt het best uitvoerbaar, in de ogen van het kind? Hoe kijk jij
                    daar als professional tegenaan? In deze fase is het van belang dat je enerzijds de
                    zelfredzaamheid van het kind stimuleert. Dat geeft het kind een gevoel van regie. Dat
                    is juist tijdens en na zo’n gesprek van belang, want door met jou te bespreken hoe
                    het thuis (echt) gaat, kan het kind juist het gevoel krijgen dat hij regie verliest, omdat
                    jij bepaalde acties gaat nemen. Anderzijds is het van belang dat je professionele
                    verantwoordelijkheid neemt, indien nodig zelf ideeen aandraagt en duidelijk
                    communiceert wat je gaat doen en waarom. Er zijn daarbij zaken waar het kind
                    invloed op heeft of over kan meedenken en er zijn ook zaken waarbij dat niet zo is,
                    bijvoorbeeld omdat je volgens de wet bepaalde stappen moet zetten, ook als het kind
                    dat niet wil.
                </p>

                <h3>Afronden.</h3>
                <p className={'text'}>
                    Een goed gesprek verdient een duidelijke afronding. Kinderen hebben nog niet altijd
                    voldoende gesprekservaring om het gesprek uit zichzelf af te ronden. Neem daarin
                    dus gerust de leiding. Dat kun je doen door even terug te komen op de verwachting
                    die het kind had uitgesproken in fase 3 of eerstvolgende stap die je hebt besproken
                    in fase 3 en aan te kondigen wanneer je het kind weer zult zien of hem bijvoorbeeld
                    succes te wensen, of iets anders dat op dat moment passend is. Wanneer gesprek
                    emotioneel was voor het kind, is het goed om nog even ‘toe te dekken’ door hem te
                    vragen naar het hier-en-nu te halen (bijvoorbeeld: ‘Wat ga je zometeen doen?’)
                </p>

                <p><strong>Gespreksvaardigheden die helpend zijn om het gesprek aan te gaan met
                    ouders/verzorgers</strong></p>

                <p className={'text'}>
                    Praten met ouders over je zorgen is misschien wel de moeilijkste stap binnen de
                    Meldcode kindermishandeling. Je weet bijvoorbeeld niet zeker of wat je ziet wel klopt;
                    je bent bang om ouders vals te beschuldigen. Het kan spannend of lastig zijn om
                    jouw zorgen over een kind of de gezinssituatie te bespreken met een ouder. Toch is
                    het belangrijk om dit gesprek te voeren. Waar moet je rekening mee houden als je
                    met ouders in gesprek gaat? En welke gesprekstechnieken of vragen kan je hierbij
                    gebruiken?
                </p>
                <p className={'text'}>
                    In uitzonderlijke situaties kan er voor gekozen worden om niet met ouders in gesprek
                    te gaan. Dat is het geval wanneer daarmee de veiligheid van betrokkenen ernstig in
                    het geding is (denk aan seksueel geweld, huwelijksdwang, eergerelateerd geweld,
                    loverboy problematiek). Vraag dan advies aan een deskundige zoals Veilig Thuis.
                    Soms is het wel mogelijk om samen met een andere professional het gesprek aan te
                    gaan. Noteer de redenen om (nog) niet met ouders in gesprek te gaan altijd in het
                    dossier.
                </p>

                <h3>Bespreek je zorgen direct</h3>
                <p className={'text'}>
                    Wacht niet tot je zeker weet dat er iets aan de hand is, maar leg kleine én grote
                    zorgen direct aan de ouders voor. Misschien kunnen zij je zorgen meteen
                    wegnemen. Hoe langer je wacht met het bespreken van je zorgen, hoe groter de
                    kans is dat ouders het gevoel krijgen dat je niet eerlijk bent. Als je ook kleine zorgen
                    met hen deelt, is het voor hen makkelijker met jou te praten over grotere zorgen.
                </p>

                <h3>Oordeel niet</h3>
                <p className={'text'}>
                    Leg je zorgen zonder oordeel voor. Je weet niet of er ook daadwerkelijk sprake is van
                    kindermishandeling. Beschuldig ouders niet: je praat niet over een vermoeden van
                    kindermishandeling of iets dat ouders niet goed doen. Je vertelt ouders dat je iets
                    gezien of gehoord hebt waar je je zorgen over maakt. Je blijft feitelijk en hebt geen
                    oordeel.
                </p>

                <h3>Wees nieuwsgierig</h3>
                <p className={'text'}>
                    Wees nieuwsgierig naar wat ouders te zeggen hebben. Vraag hen wat zij vinden van
                    de zorgen die jij hebt, van het gesprek en hoe hun kind thuis is. Bedenkt niet alvast
                    wat zij zullen gaan zeggen, vul niet in, maar sta open voor hun antwoord. Dat helpt
                    hen te vertellen wat zij echt denken. Je weet ten slotte niet wat de reden is.
                    Uiteindelijk wil geen enkele ouder zijn kind mishandelen, maar kunnen er redenen
                    zijn waarom dit wel gebeurt. Ouders moeten ruimte voelen om hierover te praten
                    zodat er indien nodig hulp kan komen. Oordelen of invullen helpt niet om de situatie
                    te verbeteren.
                </p>

                <h3>Weet wat je wilt bereiken</h3>
                <p className={'text'}>
                    Het is belangrijk dat je weet wat het doel is van het gesprek. Iets kleins of iets wat
                    onschuldig lijkt, kun je kort met de ouders bespreken op het moment dat zij hun kind
                    ophalen. Denk je dat er meer aan de hand is of heb je al vaker kleine dingen met hen
                    besproken, maak dan een afspraak voor een later moment. Bedenk dan wanneer,
                    waar en hoe je dit gesprek wilt voeren. Neem de tijd voor zo’n gesprek. Je kan dan
                    ook bedenken of je dat gesprek alleen wilt voeren of misschien samen met de
                    leidinggevende of de aandachtsfunctionaris. Vertel dat dan ook aan de ouders.
                </p>

                <h3>Luister actief</h3>
                <p className={'text'}>
                    Actief luisteren betekent: doorvragen en samenvatten. Laat zien dat je aandachtig
                    luistert. Herhaal de belangrijkste dingen die de ouder heeft verteld. Geef ruimte aan
                    emoties die soms hoog oplopen: boosheid, verdriet of onbegrip. Laat de ander
                    ervaren dat je wil helpen.
                </p>

                <h3>Bouw het gesprek op</h3>
                <p className={'text'}>
                    Laat ouders eerst weten dat je het fijn vindt dat ze er zijn en vertel waarom je een
                    gesprek met hen wilde. Daarna kun je kort en zonder oordeel zeggen wat je is
                    opgevallen aan hun kind en dat je je daar zorgen over maakt.
                </p>

                <h3>Zoek samenwerking</h3>
                <p className={'text'}>
                    De meeste ouders willen het beste voor hun kind. En vinden het daarom fijn dat jij
                    hen vertelt wat je opvalt aan hun kind. Laat ouders daarom weten dat je samen een
                    oplossing wilt zoeken voor mogelijke problemen. En dat je hen vertelt welke stappen
                    je wilt nemen. Doe niets achter hun rug om: dat roept weerstand op en vergroot de
                    kans dat ouders kwaad worden of weglopen. Ook als je wilt overleggen met je
                    leidinggevende, de aandachtsfunctionaris of Veilig Thuis vertel je dat aan ouders.
                    Het is niet erg om aan te geven dat je niet alles weet en graag anderen erbij betrekt
                    om tot passende hulp te komen die bij ouders past.
                </p>

                <h3>Geef ruimte aan emoties</h3>
                <p className={'text'}>
                    Het kan zijn dat ouders boos of verdrietig reageren op je zorgen. Dat is heel
                    voorstelbaar: je praat met ouders over hun manier van opvoeden en de zorgen over
                    hun kinderen. Zeker als ouders de zorgen zelf niet herkennen of het gevoel hebben
                    dat zij die zorgen veroorzaken, kunnen de emoties hoog oplopen. Het is belangrijk
                    dat daar ruimte voor is: als iemand mag laten merken hoe hij of zij zich voelt; is de
                    kans groot dat deze emoties sneller zullen zakken.
                </p>

                <h3>Beloof geen geheimhouding</h3>
                <p className={'text'}>
                    Je mag ouders die daarom vragen, geen geheimhouding toezeggen. Als je
                    geheimhouding belooft, kun je in een lastige situatie komen: je wilt hun vertrouwen
                    niet beschamen, maar als zij jou iets vertellen wat ernstig is, moet je actie
                    ondernemen en anderen betrekken om de situatie te veranderen. Je kunt wel
                    beloven dat je niets zult doen, zonder eerst met hen te overleggen.
                </p>

                <h3>Maak afspraken</h3>
                <p className={'text'}>
                    Spreek met elkaar af wat jij gaat doen en wat zij gaan doen om ervoor te zorgen dat
                    het beter gaat met het kind. Leg de afspraken vast in het kind dossier. Vraag ouders
                    af en toe hoe het gaat. Als er geen verbetering is of als er nieuwe zorgen zijn, maak
                    dan een nieuwe afspraak en bespreek wat jullie verder kunnen doen.
                </p>

                <p className={'quote-source'}>(<strong>Bron</strong>: Augeo, 2022)</p>
            </Panel>
        </div>
    </Modal>
);


export default SnavelIngredienten;
